'use client'

import { type ReactNode, Suspense } from 'react'

import dynamic from 'next/dynamic'

const CoverageMap = dynamic(() => import('./coverage-map-interactive').then((module) => module.CoverageMapInteractive))

export const CoverageMapLazy = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<div className="ht-map not-prose">{children}</div>}>
    <CoverageMap>{children}</CoverageMap>
  </Suspense>
)
